import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { DataGrid } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import { createProductEvent, editProductEvent } from '../../../_events/products/create_product.event';
import { findProductsByCompanyEvent } from '../../../_events/products/findProducts.event';
import { message } from "antd";
import RolWrapper from "../../hoc/roles_wrapper";
import { ROLES } from "../../../_config/roles";
import ExcelButtonDownload from "./excel_button_download";

const ButtonRolAuthComponent = RolWrapper(Button, [ROLES.root, ROLES.admin]);

const Products = () => {

    const [render, setRender] = useState('info');
    const [item, setItem] = useState(null);

    const columns = [
        { field: 'ref', headerName: 'Referencia', width: 300 },
        { field: 'description', headerName: 'descripción', width: 400 },
        { field: 'price_mt', headerName: 'Precio MT genérico', width: 200 },
        { field: 'price_kg', headerName: 'Precio KG genérico', width: 200 },
        { field: '', headerName: 'Acciones', width: 100, sortable: false,
            renderCell: (params) => {
                const onClick = (e) => {
                    e.stopPropagation(); // don't select this row after clicking
                    setItem(params.row); setRender('form');
                };    
                return <ButtonRolAuthComponent onClick={onClick}>Editar</ButtonRolAuthComponent>;
            }
        },
    ];

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <div style={{display: 'flex', flexDirection: 'row', width:'100%'}}>
                    <Typography variant="h6" component="h6">
                        Productos
                    </Typography>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', width:'100%'}}>
                        <ExcelButtonDownload />
                        {
                            render === 'info' ? 
                            <ButtonRolAuthComponent onClick={() => {setItem(null);setRender('form');}} variant="contained">Crear nuevo</ButtonRolAuthComponent>
                            :
                            <Button onClick={() => setRender('info')} variant="contained">Ver listado</Button>
                        }
                    </div>
                </div>
                <hr />
                {
                    render === 'info' ? <ProductInfo columns={columns} /> : <ProductForm item={item} />
                }                
            </Grid>
        </Grid>
    );
}

const ProductInfo = (props) => {

    const [products, setProducts] = useState([]);

    const findProducts = () => {
        findProductsByCompanyEvent()
        .then(data => {
            setProducts(data.list);
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    useEffect(() => {
        findProducts();
    }, []);   

    return(
        <div style={{height:450, width: '100%' }}>
            <DataGrid
                rows={products}
                columns={props.columns}
                pageSize={8}
                rowsPerPageOptions={[8]}
                checkboxSelection={false}
                getRowId={(p) => p.uuid}
            />
        </div>
    );
}

const ProductForm = (props) => {
    let { item } = props; 

    const createProduct = () => {
        createProductEvent()
        .then(data => {
            message.success('Creado');
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    const editProduct = (id) => {
        editProductEvent(id)
        .then(data => {
            message.success('Actualizado');
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    return(
        <div style={{width: '100%'}}>
            <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="product_ref" 
                        label="Referencia" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.ref : null}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="product_description" 
                        label="Descripción" 
                        variant="outlined"
                        size="small"
                        defaultValue={item ? item.description : null}
                    />        
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="product_price_mt" 
                        label="Precio por Metro" 
                        variant="outlined"
                        size="small"
                        type="number"
                        defaultValue={item ? item.price_mt : 0}
                    />        
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField 
                        error={false}
                        required
                        style={{width: '100%'}} 
                        id="product_price_kg" 
                        label="Precio por Kilo" 
                        variant="outlined"
                        size="small"
                        type="number"
                        defaultValue={item ? item.price_kg : 0}
                    />        
                </Grid>
                <Grid item xs={12} md={12}>
                    {
                        item ? <Button style={{width: '100%'}} onClick={() => editProduct(item.uuid)} variant="contained">Editar</Button>
                        : <Button style={{width: '100%'}} onClick={() => createProduct()} variant="contained">Guardar</Button>
                    }      
                </Grid>                
            </Grid>
        </div>
    );
}

export default Products;